module.exports = __webpack_public_path__ + "static/media/flower2.463890ab.png";